export default __webpack_public_path__ + "static/media/roberto-podadera-1.e3134c8a.webp";